import styled from "styled-components";
import {
  NavBar as PantheonNav,
  TABLET,
  MOBILE,
  EXTRA_LARGE,
} from "@minerva-analytics/pantheon";
import {
  BACKGROUND_COLOR,
  FOOTER_COLOR,
  HEADER_FONT,
  HOVER_COLOR,
} from "../../theme";

const NavBar = styled(PantheonNav)`
  z-index: 1;

  @media (max-width: ${EXTRA_LARGE}) {
    background-color: ${BACKGROUND_COLOR};
  }

  img {
    width: auto;
    height: 80px;
    @media (max-width: ${TABLET}) {
      height: 45px;
      margin-top: 0;
      padding-bottom: 15px;
    }
    @media (max-width: ${MOBILE}) {
      height: 45px;
      margin-top: 0;
      margin-left: 10%;
      padding-bottom: 15px;
    }
    margin-top: 20px;
    margin-left: 10%;
  }

  a {
    text-transform: uppercase;
    font-size: 22px;
    font-weight: 600;
    font-family: ${HEADER_FONT};
    letter-spacing: 0.55px;
    z-index: 1;
    @media (max-width: ${TABLET}) {
      color: ${FOOTER_COLOR};
    }
  }

  button {
    @media (max-width: ${TABLET}) {
      display: none;
    }
    :hover {
      background-color: ${HOVER_COLOR};
    }
  }
`;

export { NavBar };
